import React, { useContext } from 'react'
import formStyles from 'styles/form.module.scss'
import { Field } from 'react-final-form'
import DeviceId from 'utils/detectDevice'
import { required, inputHasErr, composeValidators } from 'utils/validations'
import { FormDataContext } from 'providers/FormData'
import Dropdown from 'react-dropdown'
import useTracking from 'hooks/useTracking'
import FieldTracking from 'components/FieldTracking'

const Religion = ({ domainReligion }) => {
  const { formData, loading } = useContext(FormDataContext)
  const religionOptions = formData.religions
  const handleChange = useTracking('community')
  return (
    <div className="form-row">
      <label className={`${formStyles.label} col-md-12`}>Religion</label>
      <Field
        name="community"
        validate={composeValidators(required('community'))}
      >
        {({ input, meta }) =>
          !loading && (
            <div className="col-md-12">
              {DeviceId.isMobile() && (
                <select
                  data-testid="community_selector"
                  className={`form-control ${inputHasErr(meta) &&
                    formStyles.inputError} ${formStyles.selectMobile}`}
                  {...input}
                  disabled={domainReligion !== 'Select'}
                >
                  <option value={domainReligion} hidden>
                    {domainReligion}
                  </option>
                  {religionOptions.map((option, index) => {
                    return (
                      <option value={option.value} key={index}>
                        {option.label}
                      </option>
                    )
                  })}
                </select>
              )}

              {DeviceId.isDesktop() && (
                <Dropdown
                  controlClassName="community_selector"
                  menuClassName="community_options"
                  options={religionOptions}
                  value={domainReligion}
                  placeholder={domainReligion}
                  onBlur={handleChange()}
                  className={`${inputHasErr(meta) && formStyles.inputError}`}
                  disabled={domainReligion !== 'Select'}
                  {...input}
                />
              )}

              {meta.touched && meta.error && (
                <span
                  data-testid="community_error"
                  className={formStyles.error}
                >
                  {meta.error}
                </span>
              )}
            </div>
          )
        }
      </Field>
      <FieldTracking name="community" />
    </div>
  )
}

export default Religion
